
import {defineComponent} from "vue";
import {mapState} from "pinia";
import {useAnnouncementStore} from "@/stores/AnnouncementStore";

export default defineComponent({
  name: 'AnnouncementModal',
  computed: {
    ...mapState(useAnnouncementStore, ["getActiveAnnouncement"]),
  },
  methods: {
    close(): void {
      if (this.getActiveAnnouncement) {
        useAnnouncementStore().dismissForSession(this.getActiveAnnouncement.code);
      }
    },
    doNotShowAgain(): void {
      if (this.getActiveAnnouncement) {
        useAnnouncementStore().dismissPermanently(this.getActiveAnnouncement.code);
      }
    },
  },
});
